import { Star } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Krizel Mendoza',
      role: 'Marketing Director',
      company: 'TriJem33 Consulting LLC',
      content: 'The support team has been instrumental in helping us scale our digital presence. Their expertise and quick response times have made a significant difference in our operations.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ray Cabalan',
      role: 'Owner',
      company: 'RAC Financial LLC',
      content: "We switched to this support service last year, and it's been a game-changer. The dedicated account manager and 24/7 support have been invaluable for our growing team.",
      rating: 5,
    },
    {
      id: 3,
      name: 'Marygael Jumao-as',
      role: 'Operations Manager',
      company: 'Skyhorn Entertainment',
      content: 'The level of technical expertise and customer service is outstanding. They have helped us resolve complex issues quickly and provided excellent guidance for our digital strategy.',
      rating: 5,
    }
  ];

  // Generate initials for avatar placeholder
  const getInitials = (name) => {
    return name
      .split(' ')
      .map(part => part[0])
      .join('')
      .toUpperCase();
  };
  
  // Adjust font size based on initials length
  const getInitialFontSize = (initials) => {
    return initials.length > 2 ? 'text-base' : 'text-xl';
  };

  return (
    <section id="testimonials" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-primary font-semibold text-sm uppercase tracking-wider mb-2 block">Testimonials</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it - hear from our satisfied customers
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 p-8 border border-gray-100 hover:-translate-y-1"
            >
              <div className="flex items-center mb-6">
                <div className="relative flex-shrink-0 w-16 h-16 mr-4">
                  <div className="absolute inset-0 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 shadow-md"></div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    {(() => {
                      const initials = getInitials(testimonial.name);
                      return (
                        <span className={`text-white ${getInitialFontSize(initials)} font-semibold leading-none`}>
                          {initials}
                        </span>
                      );
                    })()}
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">
                    {testimonial.name}
                  </h3>
                  <p className="text-gray-600">
                    {testimonial.role}, {testimonial.company}
                  </p>
                </div>
              </div>
              <div className="flex mb-4 bg-yellow-50 rounded-full py-1 px-3 w-fit">
                {Array.from({length: testimonial.rating}).map((_, i) => (
                  <Star
                    key={i}
                    className="h-5 w-5 text-yellow-400 fill-current"
                  />
                ))}
              </div>
              <p className="text-gray-700 italic">
                "{testimonial.content}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 